import { Identifier } from "../../id";
export class CrossSellingListId extends Identifier {
    constructor(id) {
        super("CrossSellingListId", id);
    }
}
